import { Link } from 'react-router-dom';
import { Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <span className="font-display text-3xl tracking-tight text-[#D2FF00]">INDIGO</span>
              <span className="font-display text-3xl tracking-tight text-white">SQUARE</span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed max-w-md mb-6">
              Your gateway to the hottest sneakers and streetwear. We connect you directly to official brand stores 
              so you can cop the latest drops with confidence.
            </p>
            <div className="flex gap-4">
              <a href="#" className="p-2 bg-white/5 hover:bg-[#D2FF00] hover:text-black transition-all">
                <Instagram size={20} />
              </a>
              <a href="#" className="p-2 bg-white/5 hover:bg-[#D2FF00] hover:text-black transition-all">
                <Twitter size={20} />
              </a>
              <a href="#" className="p-2 bg-white/5 hover:bg-[#D2FF00] hover:text-black transition-all">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-lg uppercase mb-6">SHOP</h4>
            <ul className="space-y-3">
              <li><Link to="/shop?category=sneakers" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Sneakers</Link></li>
              <li><Link to="/shop?category=apparel" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Apparel</Link></li>
              <li><Link to="/shop?category=accessories" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Accessories</Link></li>
              <li><Link to="/shop?is_hot=true" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Hot Drops</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg uppercase mb-6">SUPPORT</h4>
            <ul className="space-y-3">
              <li><Link to="/size-guide" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Size Guide</Link></li>
              <li><Link to="/premium" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Premium Membership</Link></li>
              <li><a href="#" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">FAQ</a></li>
              <li><a href="#" className="text-white/60 hover:text-[#D2FF00] text-sm transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Indigo Square. All rights reserved.
          </p>
          <p className="text-white/40 text-xs">
            Affiliate Disclosure: We earn commission from qualifying purchases.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
